import { render } from "./WorkflowDialog.vue?vue&type=template&id=6263c1b7&ts=true"
import script from "./WorkflowDialog.vue?vue&type=script&lang=ts"
export * from "./WorkflowDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__